import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=7c74110a&scoped=true&"
import script from "./project-card.vue?vue&type=script&lang=js&"
export * from "./project-card.vue?vue&type=script&lang=js&"
import style0 from "./project-card.vue?vue&type=style&index=0&id=7c74110a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74110a",
  null
  
)

export default component.exports